import PolicyDocPage from "@/components/PolicyDocPage";

const SECTIONS = [
  {
    n: 1,
    title: "Information We Collect",
    paragraphs: ["We may collect the following types of personal information:"],
    bullets: [
      "Identity and KYC information (Name, Date of Birth, PAN, Aadhaar, Voter ID, Passport, etc.)",
      "Contact information (Mobile number, Email address, Residential address)",
      "Financial information (Income, Bank statements, Credit history, Existing loans)",
      "Employment and business details",
      "Device and usage data when you visit our website or use our online platforms",
      "Photographs and documents uploaded during the application process",
    ],
  },
  {
    n: 2,
    title: "How We Use Your Information",
    paragraphs: ["We use your personal information for the following purposes:"],
    bullets: [
      "Processing and evaluating your loan application",
      "Conducting credit checks and risk assessment through credit bureaus",
      "Disbursing loans and managing repayment schedules",
      "Communicating with you regarding your loan, offers, and service updates",
      "Preventing fraud, money laundering, and other illegal activities",
      "Complying with legal and regulatory requirements",
    ],
  },
  {
    n: 3,
    title: "Sharing of Information",
    paragraphs: ["We may share your information with:"],
    bullets: [
      "Credit Information Companies (CIBIL, Equifax, Experian, CRIF) for credit assessment",
      "Banks, financial institutions, and collection agencies for loan servicing and recovery",
      "Government authorities and regulators as required by law",
      "Service providers and technology partners who assist us in delivering our services",
    ],
    // closing paragraph
    sub: undefined,
  },
  {
    n: 4,
    title: "Data Security",
    paragraphs: [
      "We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.",
    ],
  },
  {
    n: 5,
    title: "Your Rights",
    paragraphs: ["You have the right to:"],
    bullets: [
      "Access the personal information we hold about you",
      "Request correction of inaccurate or incomplete information",
      "Request deletion of your data (subject to legal and regulatory retention requirements)",
      "Withdraw consent for certain processing activities (this may affect our ability to provide services)",
    ],
  },
  {
    n: 6,
    title: "Data Retention",
    paragraphs: [
      "We retain your personal information for as long as necessary to fulfill the purposes for which it was collected, including legal, regulatory, accounting, and reporting requirements. Loan-related records are generally retained for a minimum period as prescribed under applicable laws and RBI guidelines.",
    ],
  },
  {
    n: 7,
    title: "Cookies and Website Usage",
    paragraphs: [
      "Our website may use cookies and similar tracking technologies to enhance user experience, analyze traffic and improve our services. You can manage your cookie preferences through your browser settings.",
    ],
  },
  {
    n: 8,
    title: "Grievance Redressal",
    paragraphs: [
      "If you have any questions or concerns about this Privacy Policy or how we handle your data, please contact our Grievance Officer at the address shown below.",
    ],
  },
  {
    n: 9,
    title: "Changes to This Policy",
    paragraphs: [
      "We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on our website with an updated effective date. We encourage you to review this policy periodically.",
    ],
  },
  {
    n: 10,
    title: "Contact Us",
    paragraphs: [
      'For any privacy-related queries, please write to us at <a href="mailto:sahyogpfir@gmail.com" class="text-[#F0D788] hover:underline">sahyogpfir@gmail.com</a> or visit our office at the address shown below.',
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <PolicyDocPage
      testId="privacy-policy-page"
      eyebrow="Sahyog Finance · Legal"
      title={
        <>
          Privacy <em className="not-italic text-[#D4AF37]">Policy</em>
        </>
      }
      intro='Sahyog Finance ("we", "us", or "our") is committed to protecting the privacy of our customers, applicants and website visitors. This Privacy Policy explains how we collect, use, disclose and safeguard your personal information when you apply for a loan, use our services or visit our website.'
      sections={SECTIONS}
      lastUpdated="June 2026"
    />
  );
}
